webpackJsonp([212839066777427],{

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: "The musings of a freelance web developer",
	      meta: [{
	        name: 'description', content: 'Code Barn, latest in technology, trends and gossip'
	      }],
	      bodyAttributes: { class: '__static' } }),
	    _react2.default.createElement(
	      "div",
	      { className: "wrapper white" },
	      _react2.default.createElement(
	        "div",
	        { className: "section columnar story" },
	        _react2.default.createElement(
	          "header",
	          null,
	          _react2.default.createElement(
	            "h1",
	            null,
	            "Blog"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Latest in technology, trends and gossip"
	          )
	        ),
	        data.allMarkdownRemark.edges.map(function (_ref2, index) {
	          var node = _ref2.node;
	          return _react2.default.createElement(
	            "article",
	            { key: index },
	            _react2.default.createElement(
	              "h2",
	              null,
	              node.frontmatter.title
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              node.excerpt
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: node.fields.slug },
	                "Read more"
	              )
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-a3825a1aee0e2e77ac9b.js